import { apiSlice } from '@/features/api/apiSlice';

export type CrossClientPreview = {
  client: string;
  label: string;
  imageUrl: string | null;
  status: 'ok' | 'warning' | 'error';
  warnings: string[];
  renderedAt: string;
};

export type CrossClientResponse = {
  provider: string;
  previews: CrossClientPreview[];
};

export const previewApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    crossClient: b.query<CrossClientResponse, string>({
      query: (templateId) => `/templates/${templateId}/cross-client`,
    }),
  }),
});

export const { useCrossClientQuery } = previewApi;
